'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _options = require('../common/options');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadarComponent = function (_BaseComponent) {
    (0, _inherits3.default)(RadarComponent, _BaseComponent);

    function RadarComponent(props) {
        (0, _classCallCheck3.default)(this, RadarComponent);
        return (0, _possibleConstructorReturn3.default)(this, (RadarComponent.__proto__ || (0, _getPrototypeOf2.default)(RadarComponent)).call(this, props));
    }

    /**
     * 矫正 option
     */


    (0, _createClass3.default)(RadarComponent, [{
        key: 'packageOption',
        value: function packageOption() {
            var option = JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _options.RadarOption)));
            var _props = this.props,
                type = _props.type,
                color = _props.color,
                title = _props.title,
                subTitle = _props.subTitle,
                _props$titleX = _props.titleX,
                titleX = _props$titleX === undefined ? 'left' : _props$titleX,
                _props$orient = _props.orient,
                orient = _props$orient === undefined ? 'horizontal' : _props$orient,
                _props$legendY = _props.legendY,
                legendY = _props$legendY === undefined ? 'auto' : _props$legendY,
                _props$legendX = _props.legendX,
                legendX = _props$legendX === undefined ? 'center' : _props$legendX,
                _props$radius = _props.radius,
                radius = _props$radius === undefined ? '60%' : _props$radius,
                _props$center = _props.center,
                center = _props$center === undefined ? ['50%', '50%'] : _props$center,
                hasLegend = _props.hasLegend,
                hasToolbox = _props.hasToolbox,
                hasTooltip = _props.hasTooltip,
                animation = _props.animation,
                data = _props.data;

            if (color && color.length) {
                option.color = color;
            }
            option.title.text = title;
            option.title.subtext = subTitle;
            option.title.x = titleX;
            option.tooltip.show = hasTooltip;
            option.legend.show = hasLegend;
            option.legend.bottom = legendY;
            option.legend.x = legendX;
            option.legend.orient = orient;
            option.toolbox.show = hasToolbox;
            option.animation = animation;

            // 设置 series
            this.collectionSeries(data, option);
            option.radar.radius = radius;
            option.radar.center = center;
            if (type === 'area') {
                option.radar.shape = 'circle';
                option.series.areaStyle = {
                    normal: {}
                };
            }

            return option;
        }

        /**
         * 
         * 收集 series
         */

    }, {
        key: 'collectionSeries',
        value: function collectionSeries(data, defaultOption) {
            var type = this.props.type;

            var max = data.max;
            var datas = data.data || [];
            var yData = [];
            var isMaxArrayType = false;
            defaultOption.legend.data = [];
            defaultOption.radar.indicator = [];
            defaultOption.series = {
                type: 'radar',
                data: []
            };
            if (Object.prototype.toString.call(max) === '[object Array]') {
                isMaxArrayType = true;
            }
            if (Object.prototype.toString.call(datas) === '[object Array]' && datas.length) {
                datas.forEach(function (item) {
                    defaultOption.radar.indicator = [];
                    yData = [];
                    defaultOption.legend.data.push(item.name);
                    item.data.forEach(function (obj, index) {
                        yData.push(obj.value);
                        defaultOption.radar.indicator.push({
                            name: obj.name,
                            max: (isMaxArrayType ? max[index] : max) || obj.value
                        });
                    });
                    defaultOption.series.data.push({
                        value: yData,
                        name: item.name
                    });
                });
            } else if (Object.prototype.toString.call(datas) === '[object Object]') {
                defaultOption.legend.data.push(datas.name);
                datas.data.forEach(function (obj, index) {
                    yData.push(obj.value);
                    defaultOption.radar.indicator.push({
                        name: obj.name,
                        max: (isMaxArrayType ? max[index] : max) || obj.value
                    });
                });
                defaultOption.series.data.push({
                    value: yData,
                    name: datas.name
                });
            }
        }
    }]);
    return RadarComponent;
}(_Base2.default);

exports.default = RadarComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/Radar.js
// module id = 602
// module chunks = 0